exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vertical-text {\n    -webkit-writing-mode: vertical-rl;\n    -ms-writing-mode: tb-rl;\n        writing-mode: vertical-rl;\n    text-align: center;\n    line-height: 2;\n}\n.invoiceBorder {\n    border-right: 0.5px solid;\n    border-bottom: 0.5px solid;\n    border-color: black;\n}\n", ""]);

// exports
